import { IDB_rowRead, IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { Type_ISmartDataOrdering } from '../Type/Type.hive'

export function IDB_smartDataOrderingRead(source: never) {
    return IDB_rowRead<Type_ISmartDataOrdering>(IDB_globalDb, 'smart_data_ordering', source)
}

export function IDB_smartDataOrderingsDelete(source: never[]) {
    return IDB_rowsDelete(IDB_globalDb, 'smart_data_ordering', source)
}

export function IDB_smartDataOrderingsReadAll() {
    return IDB_rowsReadAll<Type_ISmartDataOrdering>(IDB_globalDb, 'smart_data_ordering')
}

export function IDB_smartDataOrderingsWrite(smartDataOrderings: Type_ISmartDataOrdering[]) {
    return IDB_rowsWrite(IDB_globalDb, 'smart_data_ordering', smartDataOrderings)
}
